import React from "react";
import axios from "axios";
import "../auth.css";
import "../card.css";
import "../sidemenu.css";
import "../just.css";
import { reactLocalStorage } from "reactjs-localstorage";
import i18n from "../i18n";
import { connect } from "react-redux";
import Menutest from "./menu.js";
import Table from "react-bootstrap/Table";
import {
  Grid,
  Segment,
  Divider,
  Header,
  Icon,
  Form,
  Input,
  Menu,
  Checkbox,
  Button,
  Label,
  Modal,
  Message,
  Pagination,
} from "semantic-ui-react";
import { SemanticToastContainer, toast } from "react-semantic-toasts";
import "react-semantic-toasts/styles/react-semantic-alert.css";
import {
  withScriptjs,
  withGoogleMap,
  MapWithAMarker,
  Data,
} from "react-google-maps";
import { Circle, Trash } from "react-google-maps";
import {
  LoadScript,
  GoogleMap,
  DrawingManager,
  Polygon,
  Polyline,
  Marker,
  InfoWindow,
} from "@react-google-maps/api";
//import {DrawingManager} from "react-google-maps/lib/components/drawing/DrawingManager";
//import { Circle } from "react-google-maps";
//import { Descriptions } from 'antd';
import Geocode from "react-geocode";
import Autocomplete from 'react-google-autocomplete';
import { API_BASE_URL } from "../utils/endpoints";
const { MarkerWithLabel } = require("react-google-maps/lib/components/addons/MarkerWithLabel");
Geocode.setApiKey("AIzaSyDIV-I4FCXCL1mlcHpVYsxC-fVX_hY-5xo");
Geocode.enableDebug();
const libraries = ["drawing", "places"];
const google = window.google;
const googleKey = {
  key: "AIzaSyDIV-I4FCXCL1mlcHpVYsxC-fVX_hY-5xo",
  
  libraries: ["drawing", "places"].join(","),
};
const IconTrashDetailsa = {
  marginTop: 30,
  marginLeft: "15%",
  height: "auto",
};
const modEdit = { marginTop: 200, marginLeft: "30%", height: "auto" };
const modDelete = {
  marginTop: 200,
  marginLeft: "30%",
  height: "auto",
  width: 700,
  textAlign: "left",
};

const modDeletea = {
  marginTop: 200,
  marginLeft: "15%",
  height: "auto",
  width: 700,
  textAlign: "left",
};

var options = {
  drawingControl: true,
  drawingControlOptions: {
    drawingModes: ["circle"],
  },

  circleOptions: {
    fillColor: `#32CD32`,
    strokeColor: `#000000`,
    fillOpacity: 0.5,
    strokeWeight: 0.6,
    clickable: true,
    editable: true,
    draggable: true,
    zIndex: 1,
    radius: 2000,
  },
};

const labels = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
let labelIndex = 0;
var drawingManager;
var all_overlays = [];

var selectedShape;
var colors = ["#1E90FF", "#FF1493", "#32CD32", "#FF8C00", "#4B0082"];
var selectedColor;
var colorButtons = {};

var lang = i18n.language;
const polygonRef = null;
const circleRef = null;
const listenersRef = [];

const jordanCoords = [

  { lat: 29.357242948788763,lng:34.95949224853514 },
  { lat: 29.18389199055402, lng:36.07316088867186},
  { lat:29.500175899873142 , lng:36.50444464111327},
  { lat: 29.86799153520519, lng:36.753626586914045},

 

  { lat:29.997364197246604 ,lng: 37.50145391845702},
  { lat: 30.33238892992063, lng:37.66532015991209},
  { lat: 30.50061631019436, lng: 37.997126144409165},
  { lat: 31.500166297487983, lng:37.00106100463866},

 
  { lat:31.99629752358287 ,lng:38.99825529479979 },
  { lat:32.23023714181709 , lng:39.30114579391478},
  { lat: 32.3555435854215, lng:39.260081809997544},
  { lat: 32.30411916085719, lng:39.04382538986204},



  { lat: 32.47755937791626, lng:38.98611025238036},
  { lat:32.50159143717092, lng:39.0862686653137},
  { lat:33.37664020542303, lng:38.79659609222411},
  { lat:32.34103760465571, lng: 36.86840367507933},
  {lat:32.3111596976835 , lng: 36.8382831039428},


  {lat:32.32972431781741,lng:36.724894763946516},
  {lat:32.32182705250223,lng: 36.71086208248137},
  {lat:32.332915388050495, lng:36.70073342514036},
  
  {lat:32.345469373518256, lng:36.631554526329026},
  {lat:32.36023432092897, lng:36.50039386940001},
  {lat:32.37012156152168, lng:36.484625798702226},
  {lat:32.379191383579375, lng:36.395852090835554},

  {lat:32.457008173603015, lng:36.311843258380875},
  {lat:32.500632296522085, lng:36.23573494148253},
  {lat:32.52991810229745, lng:36.20132551813124},
  {lat:32.529535488767934, lng:36.2010244746208},

  {lat:32.530261834334404, lng:36.19430885934828},
  {lat:32.52780775572548, lng:36.19010251951216},
  {lat:32.51907177655439, lng:36.17894516611098},
  {lat:32.512464752628226, lng:36.16606992673872},

  {lat:32.51907177655439, lng:36.17894516611098},
  {lat:32.52341408246779, lng:36.15611420297621},
  {lat:32.522488662163575, lng:36.14364665937422},
  {lat:32.52354525302723,lng: 36.140085321903214},

  {lat:32.5255915050095, lng:36.12238747072218},
  {lat:32.5237442700621, lng:36.117876631259904},
  {lat:32.51245570527355, lng:36.078356327533704},
  {lat:32.53691459926388, lng:36.07843742990492},

  {lat:32.558621542410066,lng: 36.07123238039015},
  {lat:32.57793285885938, lng:36.06079922342299},
  {lat:32.58482347682061, lng:36.051126541614515},
  {lat:32.585594574963494,lng: 36.04913161420821},

  {lat:32.58741341786955,lng: 36.04925435972212},
  {lat:32.59074269953818, lng:36.043150288105},
  {lat:32.590834918096014, lng:36.040287734985334},
  {lat:32.59288502772438, lng:36.04003691399096},

  {lat:32.60373781563121, lng:36.033344836950285},
  {lat:32.60479796908531, lng:36.026432749867425},
  {lat:32.612269429062906,lng: 36.023860545873625},
  {lat:32.63807891956443, lng:36.02837466919421},

  {lat:32.65542566503933, lng:36.02726963353155},
  {lat:32.65698652702485, lng:36.02438622438906},
  {lat:32.65778774704546, lng:36.021406324625},
  {lat:32.65795867468653, lng:36.01786309206484},

  {lat:32.66103042718499, lng:36.00494829010962},
  {lat:32.661156186843456, lng:36.00238138163088},
  {lat:32.66018138024382, lng:35.98233190369604},
  {lat:32.662637481388856, lng:35.96598916971682},

  {lat:32.66318067022903, lng:35.96481137913464}, 
  {lat:32.66503945218275, lng:35.96331131929158},
   {lat:32.66782307684001, lng:35.96267634075878}, 
   {lat:32.67076553530109, lng:35.961358671128735},

  {lat:32.6727723030806, lng:35.95892124813793},
   {lat:32.67438366164011,lng:35.957614307343945},
    {lat:32.676579995144046,lng: 35.95524528068302},
     {lat:32.676735082972165,lng: 35.95454485440253}, 

   
     {lat:32.678090101413694,lng: 35.952491993129236}, 
     {lat:32.679851213521275,lng: 35.97229236090182}, 
     {lat:32.68126883259678,lng: 35.971986288249475}, 
     {lat:32.6831653341378,lng: 35.96972816908358}, 
     {lat:32.692754668082, lng: 35.964733595073206},
     {lat:32.69689008272754,lng:  35.9407173963785},
     {lat:32.69729863254009, lng:35.94027952575682},
     {lat:32.69890190635756, lng:35.94059539031981},
     {lat:32.699817605545725,lng: 35.94000057601927},
     {lat:32.69982281292162, lng:35.93922209930418},
     {lat:32.69939326740233,lng :35.9382410469055},
     {lat:32.69953390208137, lng:35.93776297760008},
     {lat:32.70027805529131, lng:35.93736128234862},
     {lat:32.701628484484175, lng:35.93806606721876},
     {lat:32.701887353632806, lng:35.93798087263106},
     {lat:32.70217017882881, lng:35.93805265617369},
     {lat:32.70307681636371,lng: 35.93861655616759},
     {lat:32.70323098739559, lng:35.93864005994795},
     {lat:32.70355530543832, lng:35.93866751813887},
     {lat:32.704409147236284, lng:35.93907189559935},
     
     {lat:32.70470637713591, lng:35.93915568017958},
     {lat:32.708570258250425,lng: 35.93997107172011},
     {lat:32.72048654004693, lng:35.935112955093366},
     {lat:32.72221889100152,lng: 35.91954336786269},
     {lat:32.723447136385566, lng:35.911938669204694},
     {lat:32.719330465714876, lng:35.904351336002335},
     {lat:32.72373596979006, lng:35.905673028945905},
     {lat:32.7181750694048, lng:35.89842901849745},
     {lat:32.71767027182483,lng: 35.88258457374571},
     {lat:32.731389021177705,lng: 35.87705717706679},
     {lat:32.731028703175625,lng: 35.85537624549864},
     {lat:32.7292951375434, lng:35.8528529229164},
     {lat:32.726552046451495,lng: 35.85657787513731},
     {lat:32.724818393767166,lng: 35.854397875308976},
     {lat:32.72757194971199,lng: 35.851739170074445},
     {lat:32.73059028257637, lng:35.847796958923325},
     {lat:32.73183195045331, lng:35.84470105361937},
     {lat:32.72991337985417, lng:35.84189609909056},
     {lat:32.72836620257721, lng:35.841267826080305},
     {lat:32.726591969347936,lng: 35.83524422073363},
     {lat:32.73370917429265, lng:35.82633328628538},
     {lat:32.73612264146474, lng:35.810353321075425},
     {lat:32.739160119422436,lng: 35.80925297927855},
     {lat:32.74085149820064, lng:35.81065372848509},
     {lat:32.74183132179559, lng:35.80865216445921},
     {lat:32.7409236925419, lng:35.80674843215941},
     {lat:32.736669331556165,lng: 35.804789783477766},
     {lat:32.73651973068863,lng: 35.8005686225891},
     {lat:32.74273373693388,lng: 35.798781635284406},
     {lat:32.74388361017128,lng: 35.794646305084214},
     {lat:32.748400695073926, lng:35.80024075698851},
     {lat:32.75535236219647, lng:35.79668478393553},
     {lat:32.74739005379123,lng:35.78674388122557},
     {lat:32.74640126759209, lng:35.76484159851073},
     {lat:32.744863400423405, lng:35.756102325439436},
     {lat:32.731528912512545, lng:35.74707464599608},
     {lat:32.72999078867099, lng:35.74228358459471},
     {lat:32.73297293926876, lng:35.73840574645995},
     {lat:32.732878868624425, lng:35.73679042053221},
     {lat:32.72914621722187,lng: 35.73677496337889},
     {lat:32.727896872193945,lng: 35.73473048400877},
     {lat:32.7230808872961,lng: 35.73265509033202},
     {lat:32.72305901502492,lng: 35.7294948120117},
     {lat:32.72633022249916, lng:35.729221862792954},
     {lat:32.72666938104876, lng:35.72554660034178},
     {lat:32.72235879672576, lng:35.72407202148436},
     {lat:32.723997724254644,lng: 35.71945262145994},
     {lat:32.715137569425096,lng: 35.715746444702134},
     {lat:32.718798595091556, lng:35.71078372192381},
     {lat:32.71383768641658,lng: 35.706219238281236},
     {lat:32.715910059024566, lng:35.70323062133787},
     {lat:32.71246556713448, lng:35.6986661376953},
     {lat:32.70919385107975, lng:35.68726611328123},
     {lat:32.70531576202337, lng:35.67540602111815},
     {lat:32.702116009542294, lng:35.67705226135252},
     {lat:32.69563733545448,lng: 35.674290222167954},
     {lat:32.693665198204826, lng:35.67104411315916},
     {lat:32.68586756081039, lng:35.67516998672484},
     {lat:32.68478014924521, lng:35.671215774536115},
     {lat:32.6800882630164, lng:35.66186623001097},
     {lat:32.68478014924521, lng:35.65894198608397},
     {lat:32.67755970262961, lng:35.64487175369261},
     {lat:32.686535767995345,lng: 35.634808105468736},
     {lat:32.67849506857149, lng:35.62615466308592},
     {lat:32.6777222550929, lng:35.62038854980467},
     {lat:32.680373414882496, lng:35.61722827148436},
     {lat:32.675265875217434, lng:35.60717062377928},
     {lat:32.66939175383704, lng:35.603838684082014},
     {lat:32.66905237756802, lng:35.59927420043944},
     {lat:32.65204954082403, lng:35.606585266113264},
     {lat:32.64766308284541, lng:35.564255279541},
     {lat:32.63672778749984, lng:35.56126666259764},
     {lat:32.63349708507235,lng: 35.56803182983397},
     {lat:32.5973995841451,lng: 35.56744647216795},
     {lat:32.59705993470585,lng: 35.57901815795897},
     {lat:32.56586671793416,lng: 35.57225299072264},
     {lat:32.55626745309289,lng: 35.57695822143553},
     {lat:32.54908324157012,lng: 35.568819763183576},
     {lat:32.527035902647235, lng:35.564255279541},
     {lat:32.51463835320666, lng:35.55302691650389},
     {lat:32.50155907290892, lng:35.559448760986314}


 
];


class AddArea extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      radius: 0,
      allEdits: [],
      map: null,
      path: [],
      isDrawing: false,
      shapes: [],
      drawingModes: ["circle"],
      address: '',
      city: '',
      area: '',
      state: '',
      zoom: 15,
      height: 500,
      mapPosition: {
          lat: 0,
          lng: 0,
      },
      markerPosition: {
          lat: 0,
          lng: 0,
      },
      circleData: [],
      pathCircle: [],
      Object: {},
      modalOpenUpload: false,
      modalOpenInstruction: true,
    };

    this.handleOverlayComplete = this.handleOverlayComplete.bind(this);
    this.deleteShapes = this.deleteShapes.bind(this);
    this.clearSelection = this.clearSelection.bind(this);
    this.setSelection = this.setSelection.bind(this);
    this.deletSelectedSahape = this.deletSelectedSahape.bind(this);
    this.mapMounted = this.mapMounted.bind(this);
    this.shouldComponentUpdateshouldComponentUpdate = this.shouldComponentUpdateshouldComponentUpdate.bind(
      this
    );
    this.getvalues = this.getvalues.bind(this);
  }
  mapMounted(ref) {
    this.map = ref;
  }

  shouldComponentUpdateshouldComponentUpdate(nextProps, nextState) {
    return false;
  }

  handleOpenUpload = () => {
    if (this.state.circleData.length > 0) {
      this.setState({ modalOpenUpload: true });
    }
  };
  handleCloseUpload = () => this.setState({ modalOpenUpload: false });

  
  handleOpenInstruction = () => {
  
      this.setState({   modalOpenInstruction: true,});
    
  };
  handleCloseInstruction = () => this.setState({   modalOpenInstruction: false, });



  getvalues(e) {
    const radius = this.map.getRadius();
    const center = this.map.getCenter();
    this.setState({ radius: radius });
    this.setState({
      "mapPosition.lat": center.lat(),
      "mapPosition.lng": center.lng(),
    });
    console.log("raduis", this.setState.radius);
  }

  handleOverlayComplete(e) {
    const newshape = e.overlay;
    newshape.type = e.type;

    window.google.maps.event.addListener(newshape, "click", () => {
      this.setSelection(newshape);
    });
    this.setSelection(newshape);

    this.state.shapes.push(newshape);
  }

  
  clearSelection() {
    if (selectedShape) {
      selectedShape.setEditable(false);
      selectedShape = null;
    }
  }

  setSelection(shape) {
    this.clearSelection();
    selectedShape = shape;
    shape.setEditable(true);
    //selectColor(shape.get('fillColor') || shape.get('strokeColor'));
  }

  /* toggleSelection(shape) 
  {
    selectedShape = shape;
    if (selectedShape.getEditable() === true) selectedShape.setEditable(false);
    else selectedShape.setEditable(true);
  } */

  deletSelectedSahape() {
    
    if (selectedShape) {
        for(var key in this.state.circleData){
      if(this.state.circleData[key].radius===selectedShape.radius/1000)
      {
        this.state.circleData.splice(key, 1);
      }
    }
       selectedShape.setMap(null);
    }
    var Ob ={long: "0.0", lat: "0.0", radius: 0}
    this.setState({Object:Ob})
  }

  deleteShapes() {
    var array = [];
    this.setState({ circleData: array });
    this.state.shapes.forEach((shape) => shape.setMap(null));
    var Ob ={long: "0.0", lat: "0.0", radius: 0}
    this.setState({Object:Ob})
    console.log(this.state.circleData);
  }

  noDraw = () => {
    this.setState(function set(prevState) {
      return Object.assign({}, prevState, {
        drawingModes: "maker",
      });
    });
  };




  onCircleComplete = (circle) => {
    document.getElementById("button").disabled = false;
    document.querySelector('.feilds').style='display:block'

    console.log(circle);
    const circlelat = circle.getCenter().lat();
    const circleLang = circle.getCenter().lng();
    var jordanArea = new window.google.maps.Polygon({paths: jordanCoords,});

    console.log(window.google.maps.geometry.poly.containsLocation( { lat: circlelat, lng:circleLang },jordanArea));
    window.google.maps.geometry.poly.containsLocation( { lat: circlelat, lng:circleLang }, jordanArea)?console.log("IN"):console.log("OUT");

    if(window.google.maps.geometry.poly.containsLocation( { lat: circlelat, lng:circleLang }, jordanArea)==false){
      circle.setMap(null)
    }else if(window.google.maps.geometry.poly.containsLocation( { lat: circlelat, lng:circleLang },jordanArea)==true){
      const circlelat = circle.getCenter().lat();
      const circleLang = circle.getCenter().lng();
      this.setState({mapPosition: {
        lat:circle.getCenter().lat(),
        lng: circle.getCenter().lng(),
      },})
      const radius = circle.radius;
      var Radius = radius / 1000;
      var circlesArray = ['circle'];
      var Object = { long: circleLang, lat: circlelat, radius: Radius };
      this.setState({Object:Object})
      var Ob ={long: "0.0", lat: "0.0", radius: 0}
      console.log(circleLang, circlelat, radius);
      if (Radius > 5) {

            /***********to change color of circle to red if radius > 5km */
            circle.setOptions({
              fillColor: '#FF2E2E',
              strokeColor: '#D10000'
          });
          
            /*********** clear circle from map if radius > 5km */

          setTimeout(function() {
            circle.setMap(null)
          }, 3000);

        document.getElementById("testradius").style = "display:block";
        document.getElementById("button").disabled =true;
        //circle.setMap(null);
        this.setState({Object:Ob})
        setTimeout(this.myFunctiontestradius, 5000);
      } else {
        if (this.state.circleData.length < 15) {
          this.setState({drawingModes:circlesArray})
        } else {
          
          document.getElementById("test").style = "display:block";
          document.getElementById("button").disabled = true;
          circle.setMap(null);
          this.setState({Object:Ob})
          setTimeout(this.myFunctiontest, 5000);
        }
      }
  
      this.noDraw();
  
      window.google.maps.event.addListener(circle, "radius_changed", (event) => {
        console.log("circle radius changed", circle.getRadius());
        var radius = circle.getRadius();
        console.log(radius);
        console.log(radius);
        if(radius/1000 > 5){
            /***********to change color of circle to red if radius > 5km */
        circle.setOptions({
          fillColor: '#FF2E2E',
          strokeColor: '#D10000'
      });
          document.getElementById("testradius").style = "display:block";
          document.getElementById("button").disabled = true;
          //circle.setMap(null);
          this.setState({Object:Ob})
          setTimeout(this.myFunctiontestradius, 5000);
        }
        else{
                    /***********to change color of circle to green if radius < 5km */

          circle.setOptions({
            fillColor: `#32CD32`,
            strokeColor: `#000000`,
        });
        var object = { long: circleLang, lat: circlelat, radius: radius/1000 };
        console.log("Object", object);
        this.setState({ Object: object });
        }
      });
  
      window.google.maps.event.addListener(circle, "center_changed", (event) => {
        console.log("circle center changed", circle.getCenter().toUrlValue(15));
        var circleLang = circle.getCenter().lng();
        var circlelat = circle.getCenter().lat();
        var object = { long: circleLang, lat: circlelat, radius: radius };
        this.setState({ Object: object });
      });




    }

   
  };




  myFunctiontest() {
    document.getElementById("test").style = "display:none";
  }

  myFunctiontestradius() {
    document.getElementById("testradius").style = "display:none";
    document.getElementById("button").disabled = true;
  }

  Save =() =>{
    var array=[]
    for( var key in this.state.Object){
      array.push(key)
    }
     if(array.length >0) {
      var Object=this.state.Object
      this.state.circleData.push(Object)
    
    }
    var ob = { long: "0.0", lat: "0.0", radius: "0" };
    this.setState({Object:ob})
    console.log("save",this.state.circleData)
   // document.querySelector('.button').sty
   document.getElementById("button").disabled = true
  
  
  }
 
  

  circleSubmit = () => {
    if (this.state.circleData.length > 0) {
      var token = reactLocalStorage.get("accessToken");
      var ip = API_BASE_URL;
      var s2 = "localhost:3000";
      var apiBaseUrl;
      var data = {
        area: this.state.circleData,
        area_name: this.state.areaname,
      };
      if (ip.includes(s2)) {
        apiBaseUrl =
          API_BASE_URL + "/core/user/rest/general/createOrUpdatePredefinedArea";
      } else {
        apiBaseUrl =
          API_BASE_URL +
          "/core/user/rest/general/createOrUpdatePredefinedArea";
      }
      var headers = {
        token: token,
      };
      axios
        .post(apiBaseUrl, data, { headers: headers })
        .then(function(response) {
          if (response.status === 200) {
            if (response.data.result != undefined) {
              if (response.data.status === "success") {
                window.location = "Map";
              } else {
                toast({
                  type: "warning",
                  title: i18n.t("warning.label"),
                  description: response.data.status,
                  animation: "bounce",
                  time: 5000,
                });
              }
            }
          } else if (response.status === 204) {
            console.log("Something wrong");
            toast({
              type: "error",
              title: i18n.t("error.label"),
              description: i18n.t("Something_wrong.label"),
              animation: "bounce",
              time: 5000,
            });
          } else {
            console.log("Something wrong");
            toast({
              type: "error",
              title: i18n.t("error.label"),
              description: i18n.t("Something_wrong.label"),
              animation: "bounce",
              time: 5000,
            });
          }
        })
        .catch(function(error) {
          console.log(error);
          toast({
            type: "error",
            title: i18n.t("error.label"),
            description: i18n.t("Something_wrong.label"),
            animation: "bounce",
            time: 5000,
          });
        });
    }
  };

  //////////////////////////////////////////
  ///NOT : Use to change position of shap///
  /////////////////////////////////////////
  /*  onEdit = ()=> {
    console.log(polygonRef,"polygonRef")
   if (polygonRef.current) {
      const nextPath = polygonRef.current
        .getPath()
        .getArray()
        .map((latLng) => {
          return { lat: latLng.lat(), lng: latLng.lng() };
        });
        this.setState({ path:nextPath})
    } 
  } */

  //////////////////////////////////////////
  onEdit = () => {
    console.log("circleRef", circleRef);
    this.onCircleComplete();
    /* if (circleRef.current) {
      const nextPath = circleRef.current
        .getPath()
        .getArray()
        .map((latLng) => {
          return { lat: latLng.lat(), lng: latLng.lng() };
        });
        this.setState({ path:nextPath})
    } */
  };

  //////////////////////////////////////////
  ///NOT :                               ///
  /////////////////////////////////////////
  onLoad = (circle) => {
    console.log("circle", circle);
    /*  polygonRef.current = polygon;
      
      const path = polygon.getPath();
      listenersRef.current.push(
        path.addListener("set_at", this.onEdit.bind(this)),
        path.addListener("insert_at",  this.onEdit.bind(this)),
        path.addListener("remove_at", this.onEdit.bind(this))
      );  */
  };
  //////////////////////////////////////////

  //////////////////////////////////////////
  ///NOT :                               ///
  /////////////////////////////////////////
  onUnmount = () => {
    /* listenersRef.current.forEach(listener=>listener.remove());
    polygonRef.current=null; */
  };
  //////////////////////////////////////////
  componentDidMount() {
    var lang = i18n.language;
    if (lang === "ar") {
      this.setState({ isArabic: true });}
    document.getElementById("button").disabled = true;

    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(position => {
          this.setState({
              mapPosition: {
                  lat: position.coords.latitude,
                  lng: position.coords.longitude,
              },
              markerPosition: {
                  lat: position.coords.latitude,
                  lng: position.coords.longitude,
              }
          },
              () => {
                  Geocode.fromLatLng(position.coords.latitude, position.coords.longitude).then(
                      response => {
                          console.log(response)
                          const address = response.results[0].formatted_address,
                              addressArray = response.results[0].address_components,
                              city = this.getCity(addressArray),
                              area = this.getArea(addressArray),
                              state = this.getState(addressArray);
                          console.log('city', city, area, state);
                          this.setState({
                              address: (address) ? address : '',
                              area: (area) ? area : '',
                              city: (city) ? city : '',
                              state: (state) ? state : '',
                          })
                      },
                      error => {
                          console.error(error);
                      }
                  );

              })
      });
  } else {
      console.error("Geolocation is not supported by this browser!");
  }

    var token = reactLocalStorage.get("accessToken");

    var ip = API_BASE_URL;
    var s2 = "localhost:3000";
    var apiBaseUrl;
    if (ip.includes(s2)) {
      apiBaseUrl =
        API_BASE_URL + "/core/user/rest/user/loadbytokken";
    } else {
      apiBaseUrl = API_BASE_URL + "/core/user/rest/user/loadbytokken";
    }

    var headers = { "Content-Type": "application/json", tokken: token };
    axios.get(apiBaseUrl, { headers: headers }).then((res) => {
      if (res.data.result.ErrorResutl) {
        toast({
          type: "error",
          title: i18n.t("error.label"),
          description: res.data.result.ErrorResutl,
          animation: "bounce",
          time: 5000,
        });
        window.location = "/app/";
      }
    });
  }

  getCity = (addressArray) => {
    let city = '';
    for (let i = 0; i < addressArray.length; i++) {
        if (addressArray[i].types[0] && 'administrative_area_level_2' === addressArray[i].types[0]) {
            city = addressArray[i].long_name;
            return city;
        }
    }
};

getArea = (addressArray) => {
    let area = '';
    for (let i = 0; i < addressArray.length; i++) {
        if (addressArray[i].types[0]) {
            for (let j = 0; j < addressArray[i].types.length; j++) {
                if ('sublocality_level_1' === addressArray[i].types[j] || 'locality' === addressArray[i].types[j]) {
                    area = addressArray[i].long_name;
                    return area;
                }
            }
        }
    }
};

getState = (addressArray) => {
    let state = '';
    for (let i = 0; i < addressArray.length; i++) {
        for (let i = 0; i < addressArray.length; i++) {
            if (addressArray[i].types[0] && 'administrative_area_level_1' === addressArray[i].types[0]) {
                state = addressArray[i].long_name;
                return state;
            }
        }
    }
};

onChange = (event) => {
    this.setState({ [event.target.name]: event.target.value });
};

onInfoWindowClose = (event) => { };

onMarkerDragEnd = (event) => {
    let newLat = event.latLng.lat(),
        newLng = event.latLng.lng();

    Geocode.fromLatLng(newLat, newLng).then(
        response => {
            const address = response.results[0].formatted_address,
                addressArray = response.results[0].address_components,
                city = this.getCity(addressArray),
                area = this.getArea(addressArray),
                state = this.getState(addressArray);
            this.setState({
                address: (address) ? address : '',
                area: (area) ? area : '',
                city: (city) ? city : '',
                state: (state) ? state : '',
                markerPosition: {
                    lat: newLat,
                    lng: newLng
                },
                mapPosition: {
                    lat: newLat,
                    lng: newLng
                },
            })
        },
        error => {
            console.error(error);
        }
    );
};

onPlaceSelected = (place) => {
    console.log('plc', place);
    const address = place.formatted_address,
        addressArray = place.address_components,
        city = this.getCity(addressArray),
        area = this.getArea(addressArray),
        state = this.getState(addressArray),
        latValue = place.geometry.location.lat(),
        lngValue = place.geometry.location.lng();

    console.log('latvalue', latValue)
    console.log('lngValue', lngValue)

    // Set these values in the state.
    this.setState({
        address: (address) ? address : '',
        area: (area) ? area : '',
        city: (city) ? city : '',
        state: (state) ? state : '',
        markerPosition: {
            lat: latValue,
            lng: lngValue
        },
        mapPosition: {
            lat: latValue,
            lng: lngValue
        },
    })
};



  ////

  render() {
    return (
      <>
        <div className="big_div">
          <Menutest />
          <div className="actionMenu">
            <div className="main_div_request">
              <div className="main_request">
                <Grid columns={2} divided className="fixed_profile">
                  <Grid.Row stretched className="fixed_header">
                    <Grid.Column className="grid_logo ">
                      <Segment>
                        <h3 className="text_style blue_color">
                          {reactLocalStorage.get("lang") === "ar" ? (
                            <img
                              src={require("../pictures/ArabicHedar.png")}
                              style={{
                                width: "100% !important",
                                height: "117px",
                                marginTop: "8px",
                                marginRight: "-13px",
                              }}
                              className="himage"
                            />
                          ) : (
                            <img
                              src={require("../pictures/EnglishHedar.png")}
                              style={{
                                width: "100% !important",
                                height: "117px",
                                marginLeft: "-13px",
                                marginTop: "8px",
                              }}
                              className="himage"
                            />
                          )}
                        </h3>
                      </Segment>
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              </div>
            </div>

            <br />
            <br />
            <br />
            <br />
            <div
              className="container_cards"
              style={{ paddingRight: this.state.isArabic ? "" : "20px" }}
            >
              <div
                className={
                  this.state.isArabic
                    ? "content_reportarabic"
                    : "content_report"
                }
              >
                <br />
                <Segment
                  color="black" basic
                  style={{ padding: "20px", minHeight: "200px" }}
                >
                  <br />

                  <Divider horizontal>
                    {" "}
                    <Header as="h2" color="black">
                      <Icon name="map marker outline" color="black" /> {this.state.isArabic?
                      'إضافة منطقة':'Add Region'}{" "}
                    </Header>{" "}
                  </Divider>
                  <br />
                  <div className="buttonsHeader">
                    <Button
                      floated="right"
                      icon
                      labelPosition="left"
                      basic
                      size="small"
                      onClick={this.deleteShapes}
                    >
                      <Icon name="trash alternate" /> {this.state.isArabic?'حذف جميع المساحات':"Delete All Areas"}
                    </Button>
                    <Button
                      floated="right"
                      icon
                      labelPosition="left"
                      basic
                      size="small"
                      onClick={this.deletSelectedSahape}
                    >
                       <Icon name="hand point up" /> {this.state.isArabic?'حذف المساحة المحددة':"Delete Selected Area"}
                    </Button>

                    <Button
                      floated="right"
                      icon
                      labelPosition="left"
                      basic
                      size="small"
                      onClick={this.handleOpenUpload}
                    >
                      <Icon name="save" /> {this.state.isArabic?'حفظ المنطقة':'Save Region'}
                    </Button>

                   
                      <Button
                        floated="right"
                        icon
                        labelPosition="left"
                        basic
                        size="small"
                        onClick={this.Save}
                        id="button"
                      >
                        <Icon name="save" /> {this.state.isArabic?' حفظ المساحة' :"Save Area"}
                      </Button>
                 
                  </div>

                  <br />
                  <br />
                 <div className="feilds" style={{display:'none'}}>
                 <Form >
                        <Form.Group widths='equal'>
                          <Form.Field >
                             <label>Latitude</label>
                      <Message size='tiny'>{this.state.Object.long}</Message>
                           </Form.Field>
                              
                           <Form.Field >
                             <label>Longitude</label>
                              <Message size='tiny'>{this.state.Object.lat}</Message>
                           </Form.Field>
                                        
                           <Form.Field >
                            <label>Raduis</label>
                      <Message size='tiny'>{this.state.Object.radius}{" "}Km</Message>
                             </Form.Field>         
                          </Form.Group>
                        </Form>
                 </div>
                  <div id="test" style={{ display: "none" }}>
                    <Message
                      warning
                      icon="warning circle"
                      header="Warning!"
                      content=" We are sorry you can not draw more than fifteen area circles !"
                    />
                  </div>
                  <div id="testradius" style={{ display: "none" }}>
                    <Message
                      warning
                      icon="warning circle"
                      header="Warning!"
                      content=" We are sorry you can not draw a circle with a radius greater than 5 km !"
                    />
                  </div>
                  {/* <Message
                      error
                      icon="warning circle"
                      header="Each region is a circular area or a circular area group"
                      content=" When drawing a circle and checking the value of the radius, longitude and latitude, save it before drawing another circle ."
                    /> */}
                  
                  </Segment>
                  <br />
                  <br></br>
                  <div className="map-style-AddArea">
               
                    {/* <MapWithAMarker
                    googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyDIV-I4FCXCL1mlcHpVYsxC-fVX_hY-5xo&libraries=geometry,drawing,places"
                    loadingElement={<div style={{ height: `100%` }} />}
                    containerElement={<div style={{ height: `400px` }} />}
                    mapElement={<div style={{ height: `100%` }} />}
                  /> */}
                    <LoadScript
                      googleMapsApiKey={googleKey.key}
                      libraries={libraries}
                      id="script-loader"
                      language="en"
                      region='jo'
                    >
                      <GoogleMap
                        center={{
                          lat: this.state.mapPosition.lat,
                          lng: this.state.mapPosition.lng,
                        }}
                        mapContainerClassName={"map-style"}
                        zoom={6}
                        onClick={this.clearSelection}
                        radius={this.state.radius}
                        onRadiusChanged={this.getvalues}
                      >
                             <Polygon
                          options={{
                            fillColor: `#BBD2EC`,
                            strokeColor: `#3E77B6`,
                            fillOpacity: 0.45,
                            strokeWeight: 2,
                            strokeOpacity:0.8
                          }}
                        
                     
                          ref={this.refPoly}
                              editable={false}
                              draggable={false}
                              path={jordanCoords}
                             
                            />
                        {this.state.path.length === 0 ? (
                          <DrawingManager
                            drawingMode={this.state.drawingModes}
                            options={options}
                            onCircleComplete={this.onCircleComplete.bind(this)}
                            editable
                            draggable
                            // Event used when manipulating and adding points
                            onMouseUp={this.onEdit}
                            // Event used when dragging the whole Polygon
                            onDragEnd={this.onEdit}
                            onOverlayComplete={this.handleOverlayComplete}
                          />
                        ) : (
                          (
                            <Polygon
                              options={{
                                //fillColor: `#2196F3`,
                                //strokeColor: `#2196F3`,
                                fillOpacity: 0.45,
                                strokeWeight: 0,
                              }}
                              // Make the Polygon editable / draggable
                              editable
                              draggable
                              path={this.state.path}
                              // Event used when manipulating and adding points
                              onMouseUp={this.onEdit}
                              //// Event used when dragging the whole Polygon
                              onDragEnd={this.onEdit}
                              onLoad={this.onLoad}
                              onUnmount={this.onUnmount}
                            />
                          ) || (
                            <Polyline
                              options={{
                                fillColor: `#2196F3`,
                                strokeColor: `#2196F3`,
                                fillOpacity: 0.5,
                                strokeWeight: 2,
                              }}
                              // Make the Polygon editable / draggable
                              editable
                              draggable
                              path={this.state.path}
                              // Event used when manipulating and adding points
                              onMouseUp={this.onEdit}
                              //// Event used when dragging the whole Polygon
                              onDragEnd={this.onEdit}
                              onLoad={this.onLoad}
                              onUnmount={this.onUnmount}
                            />
                          ) || (
                            <Circle
                              options={{
                                //fillColor: `#2196F3`,
                                //strokeColor: `#2196F3`,
                                fillOpacity: 0.45,
                                strokeWeight: 0.6,
                              }}
                              onClick={() => {
                                this.onSelect();
                              }}
                              onRightClick={() => {
                                this.onSelect();
                              }}
                              onRadiusChanged={console.log("me")}
                              //ref={this.mapMounted}
                              // radius={this.state.radius}
                              // onRadiusChanged={this.getvalues}
                              // center={ this.state.mapPosition}
                              // Make the Polygon editable / draggable
                              editable={false}
                              visible={true}
                              draggable={false}
                              //path={this.state.path}
                              // Event used when manipulating and adding points
                              onMouseUp={this.onEdit}
                              //// Event used when dragging the whole Polygon
                              //  onEdit = {this.getvalues}
                              // onDragEnd={this.getvalues}
                              onLoad={this.onLoad}
                              // onUnmount={this.getvalues}
                            />
                          )
                        )}
                          {/* InfoWindow on top of marker */}

                        {/*Marker*/}
                      {/*  <Marker
                            google={this.props.google}
                            name={'Dolores park'}
                            draggable={true}
                            onDragEnd={this.onMarkerDragEnd}
                            position={{ lat: this.state.markerPosition.lat, lng: this.state.markerPosition.lng }}
                        />
                        <InfoWindow
                            onClose={this.onInfoWindowClose}
                            position={{ lat: (this.state.markerPosition.lat + 0.050), lng: this.state.markerPosition.lng }}
                        >
                            <div>
                                <span style={{ padding: 0, margin: 0 }}>{this.state.address}</span>
                            </div>
                        </InfoWindow>
                        <Marker />    */}                  
                        {/* <MarkerWithLabel
                            position={{ lat: -34.397, lng: 150.644 }}
                            labelAnchor={new google.maps.Point(0, 0)}
                            labelStyle={{ backgroundColor: "yellow", fontSize: "32px", padding: "16px" }}
                        >
                            <div>Hello There!</div>
                        </MarkerWithLabel> */}


                        {/* For Auto complete Search Box */}
                        <div></div>
                       
                        
                        <Autocomplete
                            style={{
                                width: '50%',
                                height: '40px',
                                paddingLeft: '16px',
                                marginTop: '60px',
                                marginBottom: '2rem',
                                position:'absolute',
                                marginLeft:'10px'
                                
                            }}
                            
                            onPlaceSelected={this.onPlaceSelected}
                            types={['(regions)']}
                        />
                      </GoogleMap>
                    </LoadScript>
                  </div>
                  {/* <Menu compact>
                        <Menu.Item active>City</Menu.Item>
                        <Menu.Item >{this.state.city}</Menu.Item>
                        
                        <Menu.Item active>Area</Menu.Item>
                        <Menu.Item >{this.state.area}</Menu.Item>
                        
                        <Menu.Item active>State</Menu.Item>
                        <Menu.Item >{this.state.state}</Menu.Item>
                        
                        <Menu.Item active>Address</Menu.Item>
                        <Menu.Item >{this.state.address}</Menu.Item>
                      </Menu> */}
                 {/*  <br />
                  <br />
                  <Form >
                      <Form.Field >
                        <label>City</label>
                        <Message size='tiny'>{this.state.city}.</Message>
                      </Form.Field>
                      
                      <Form.Field >
                        <label>Area</label>
                        <Message size='tiny'>{this.state.area}.</Message>
                      </Form.Field>
                      
                      <Form.Field >
                        <label>State</label>
                        <Message size='tiny'>{this.state.state}.</Message>
                      </Form.Field>
                      
                      <Form.Field >
                        <label>Adress</label>
                        <Message size='tiny'>{this.state.address}</Message>
                      </Form.Field>
                  </Form>
                  */}
               
              </div>
            </div>

            <SemanticToastContainer />
          </div>

          <Modal
            size="small"
            className="add"
            style={modEdit}
            open={this.state.modalOpenUpload}
            onClose={this.handleCloseUpload}
            closeIcon={{ style: { top: '0rem', right: '0rem' }, color: 'black', name: 'close' }}
          >
            <Header icon="save" content={lang === "ar" ? "حفظ المنطقة":"Save Region"} />
            <Modal.Content scrolling>
              <Form>
                <Form.Group widths="equal">
                  <Form.Input
                    fluid
                    label= {lang === "ar" ? "الرجاء ادخال اسم لمنطقة":"Please enter a region name"} 
                    required
                    value={this.state.areaname}
                    name="areaname"
                    onChange={(areaname) => {
                      this.setState({ areaname: areaname.target.value });
                    }}
                  />
                </Form.Group>
              </Form>
            </Modal.Content>
            <Modal.Actions>
              <Button
                basic
                color="teal"
                content={lang === "ar" ? "إرسال":"Submit"}
               
                onClick={this.circleSubmit}
              />
              <Button
                basic
                color="black"
                content={lang === "ar" ?"إلغاء":"Cancel"}
                onClick={this.handleCloseUpload}
              />
            </Modal.Actions>
          </Modal>

          <Modal
            size="small"
            className="add"
            style={modEdit}
            open={this.state.modalOpenInstruction}
            onClose={this.handleCloseInstruction}
            closeIcon= {reactLocalStorage.get('lang') === "ar" ?{ style: { top: '0rem', left: '0rem',}, color: 'black', name: 'close' , textAlign:'left'} :{ style: { top: '0rem', right: '0rem',}, color: 'black', name: 'close' , textAlign:'left'}}
          >
            
            <Header style={{textAlign: reactLocalStorage.get('lang') === "ar" ? 'right' :'left'}}content={reactLocalStorage.get('lang') === "ar" ? "تعليمات حفظ المناطق":"Save Regions Instructions"} />
            <br></br>
            {reactLocalStorage.get('lang') === "ar" ?
             <Modal.Content scrolling style={{textAlign: 'right'}}>
             <p >
             
          
               
             .بإمكانك إضافة منطقة تحتوي 15 مساحة كأقصى حد
             {"  "} <Icon name='circle' color='red' /> 
              
             </p>
             
              
              
              <p >.أنقر على حفظ المساحة بعد رسم أي دائرة {"  "} <Icon name='circle' color='red' /> 
              </p>
             
              <p>
             
              
              .بعد رسم الرقم الذي تحتاجه من المناطق ، انقر فوق حفظ المنطقة لحفظ معلومات المنظقة{"  "}
              <Icon name='circle' color='red' /> 
              </p>
                
              </Modal.Content>
            :
            
            <Modal.Content scrolling>
            <p>
            <Icon name='circle' color='red' /> 
            
              
                 {"  "} You can create region with Maximum 15 Areas.
             
            </p>
            
             <p > <Icon name='circle' color='red' /> 
             
             {"  "} Click Save Area ِafter drawing any circle.
             </p>
            
             <p>
             <Icon name='circle' color='red' /> 
             
             {"  "} After drawing the number you need of circles click on Save Region to save region informations.
             </p>

             <br></br>
             <br></br>
             
               
             </Modal.Content>
            }
           
            
          </Modal>
        </div>
      </>
    );
  }
}
export default AddArea;

//https://stackoverflow.com/questions/44156349/failed-to-display-react-google-maps-searchbox

///https://www.outsystems.com/forums/discussion/34206/how-do-i-add-center-changed-and-radius-changed-events-to-a-circle-on-google-maps/
//https://stackoverflow.com/questions/14751800/how-to-get-the-radius-after-editing-circle-google-maps-ap%C3%AD
//https://stackoverflow.com/questions/12004550/how-to-delete-all-the-shape-after-draw/12006751

//////////////////////////////////////////
//https://stackoverflow.com/questions/24956635/what-event-is-triggered-if-a-google-maps-drawn-circle-is-moved
//https://stackoverflow.com/questions/29101088/what-event-is-triggered-if-a-google-maps-drawing-like-ondraw
//http://jsfiddle.net/upsidown/k0ye3v9z/
//https://stackoverflow.com/questions/12004550/how-to-delete-all-the-shape-after-draw/12006751
///https://www.outsystems.com/forums/discussion/34206/how-do-i-add-center-changed-and-radius-changed-events-to-a-circle-on-google-maps/
